<template>
  <b-modal
    id="modal-tandai-dikirim"
    title="Mark as on delivery"
    :visible="open"
    :ok-disabled="!resi || peding"
    :cancel-disabled="peding"
    @hidden="onHidden"
    @shown="onShown"
    @ok="onSubmit"
  >
    <b-card-text>
      <b-form-group
        label="No Resi"
        label-for="noResi"
      >
        <b-form-input
          id="noResi"
          v-model="resi"
          placeholder="Nomor Resi"
        />
      </b-form-group>
    </b-card-text>
  </b-modal>
</template>

<script>
import {
  BFormInput, BFormGroup, BCardText,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'

export default {
  components: {
    BFormInput,
    BFormGroup,
    BCardText,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    hide: {
      type: Function,
      default: null,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      resi: '',
      peding: false,
    }
  },
  methods: {
    ...mapActions('transaction', ['onSubmitDelivery']),
    onHidden() {
      this.hide()

      this.name = ''
    },
    onShown() {},
    async onSubmit() {
      this.peding = true
      await this.onSubmitDelivery({ idTransaction: this.data.id, resi: this.resi })
      this.peding = false
      await this.$emit('callback')
      this.onHidden()
    },
  },
}
</script>
